import React from 'react';
import getConfig from 'next/config';
import Footer from '@domain-group/fe-co-footer';

const { publicRuntimeConfig } = getConfig();

const LandingPageFooter = (): JSX.Element => (
  <div data-theme-name="domain-2022">
    <Footer baseUrl={publicRuntimeConfig.BASE_URL} />
  </div>
);

export default LandingPageFooter;
